import {CustomTextField} from "../../atoms";
import React, {FC, useState} from "react";
import {apiUrlWithStore} from "../../helper";
import cls from "./footer.module.scss"
import {spaceToUpperCaseConvertor} from "../../services/utils";
import {TranslationsType} from "../../types/homePageTypes";
import PageHeader from "../shared/PageHeader";

interface IProps {
    translationsData: TranslationsType;
    breadcrumb: Array<{ title: string; url: string }>;
    dbName: string
}

const TrackingNumber: FC<IProps> = ({
                                        translationsData,
                                        breadcrumb,
                                        dbName
                                    }) => {
    const [track, setTrack] = useState<string>('');
    const [success, SetSuccess] = useState<{ message: string, class: string }>();
    const handlerChange = (event: { target: { value: string } }): void => {
        setTrack(event.target.value);
    };

    const handlerClick = (event: { preventDefault: () => void }) => {
        event.preventDefault();
        if (track) {
            fetch(apiUrlWithStore(`/api/track/${track}`), {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            })
                .then((response) => response.json())
                .then((data) => {
                    if (data == "Wrong order number") {
                        SetSuccess({message: data, class: "text-danger"});
                    } else {
                        window.open(data.url, "_blank");
                    }
                })
                .catch((error) => console.error(error, "error"));
        }
    };
    return (
        <>
            <PageHeader dbName={dbName} header="" breadcrumb={breadcrumb}/>
            {/*TODO:change container to container from globals.module.scss when globals file will ready*/}
            <div className="container">
                <div className={cls["track-body"]}>
                    <h1>
                        {translationsData.TrackYourOrder}
                        {" "}
                    </h1>
                    <div className={cls["track-body-input"]}>
                        <CustomTextField
                            className="tracking-number-input"
                            handleChange={handlerChange}
                            inpValue={track}
                            value={translationsData.TrackYourNumber}
                        />
                        {success && (
                            <small id="passwordHelp" className={success.class}>
                                {translationsData[spaceToUpperCaseConvertor(success.message)]}
                            </small>
                        )
                        }
                        <button
                            onClick={handlerClick}
                            type="submit"
                            className={cls["tracking-number-btn"]}
                        >
                            {translationsData.Track}
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default TrackingNumber